import * as React from "react";
import type { SVGProps } from "react";

const SvgEyeCare = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 48 48" {...props}>
    <path
      fill="#142745"
      d="M24 15.88A14.56 14.56 0 0 0 11 24a14.46 14.46 0 0 0 26 0 14.56 14.56 0 0 0-13-8.12m6.41 4.31A12.4 12.4 0 0 1 34.2 24a12.4 12.4 0 0 1-3.79 3.82 11.91 11.91 0 0 1-12.82 0A12.4 12.4 0 0 1 13.8 24a12.4 12.4 0 0 1 3.79-3.82l.3-.19a6.5 6.5 0 1 0 12.22 0l.3.19zM24 21.56a2.44 2.44 0 1 1-2.44-2.44A2.44 2.44 0 0 1 24 21.56"
    />
  </svg>
);
export default SvgEyeCare;
